import { StepConfig } from '@/types';

/**
 * Paths & Prerequisites can differ between partners,
 * so each partner gets its own STEP config.
 */

export const STEP: Record<string, StepConfig> = {
  EMAIL: {
    path: '/email',
    prereqs: [],
  },
  DELIVERY: {
    path: '/delivery',
    prereqs: ['netsuiteOrderId'],
  },
  SELECT: {
    path: '/select',
    prereqs: ['email'],
  },
  REVIEW: {
    path: '/review',
    prereqs: ['sku'],
  },
  SUMMARY: {
    path: '/summary',
    prereqs: [],
  },
};

/**
 * Metrics
 */

export const DELIVERY_METRIC_NAME = 'delivery';
export const ORDER_METRIC_NAME = 'order';
export enum MetricStep {
  DELIVERY_SUBMITTED = 'delivery_submitted',
  ORDER_SUBMITTED = 'order_submitted',
  ORDER_SUCCESS = 'order_success',
  ORDER_ERROR = 'order_error',
}
